/**
 * Tiers icon — stylized three stacked layers, representing tiers/floors.
 * Represents the TiersView mode. Used in Mobile navigation.
 * Uses `currentColor` for stroke.
 */
export function Tiers({
	className,
	arrowsClassName,
	width = '1em',
	height = '1em',
	...rest
}) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={width}
			height={height}
			viewBox="0 0 24 24"
			stroke="none"
			fill="currentColor"
			strokeWidth="0"
			strokeLinecap="round"
			strokeLinejoin="round"
			aria-hidden="true"
			className={className}
			{...rest}
		>
      <path 
				d="m18.971 16.143-7.0366 3.3381-7.0366-3.3381-4.8976 2.064 11.934 5.6615 11.934-5.6615z" 
			/>
      <path 
				d="m16.513 15.107 7.3551-3.4892-4.8976-2.064-7.0366 3.3381-7.0366-3.3381-4.8976 2.064 11.934 5.6614z" 
			/>
      <path 
				d="m7.3551 8.5186 4.5791 2.1723 11.934-5.6615-11.934-5.0294-11.934 5.0294 4.9456 2.3461z" 
			/>
  </svg>
  );
}